import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ClassRoomMediaDetails from "./routes/ClassRoomMediaDetails";
export default store => ({
  path: "mediamanager",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "teacher-classroom-details" */ "./components"
        ),
        import(
          /* webpackChunkName: "teacher-classroom-details" */ "ClassRoom/modules/ClassRoomModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "classRoom",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [ClassRoomMediaDetails(store)],
});
